import React,{ useState, useEffect, useCallback } from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

// import { useSnackbar } from 'src/components/snackbar';
import Iconify from '../iconify/iconify';
import { MultiFilePreview, Upload } from './upload';
import FileUploadIcon from '@mui/icons-material/FileUpload';
// ----------------------------------------------------------------------

export default function FileUploadDialog({
  title = 'Upload Files',

  open,
  onClose,
  multiple = false,
  //
  onCreate,
  onUpdate,
  onUpload,
  //
  folderName,
  selectedBlock,
  onChangeFolderName,
  setFiles,
  files,
  type,
  ...other
}) {

  // const { enqueueSnackbar } = useSnackbar();
  // const [files, setFiles] = useState([]);
  



  useEffect(() => {
    if (!open) {
      setFiles([]);
    }
  }, [open]);
  

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const newFiles = acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );

      setFiles([...files, ...newFiles]);
    },
    [files]
  );

  const handleUpload = async() => {
    try {
        
        const formData = new FormData();

        formData.append('document', files[0]);

        // const data = {
        //   quatationId: selectedBlock?._id,
        //   filename: files[0].name,
        //   userid: currentQuatation?.user?._id,
        // };

        // await uploadDocumentForQuatation?.(formData, data);
    
    } 
    
    catch (error) {
      console.error(error)
      // enqueueSnackbar("Failed to upload document",{variant:'error'})
    }
  };

  const handleUserDocumentUpload = async() => {
      // setFiles([...files,files])
      if(files.length > 0){
        onClose()
      }
      
  };

  const handleRemoveFile = (inputFile) => {    
    const filtered = files.filter((file) => file !== inputFile);
    setFiles(filtered)
  };

  const handleRemoveAllFiles = () => {
    setFiles([]);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ p: (theme) => theme.spacing(3, 3, 2, 3) }}> {title} </DialogTitle>

      <DialogContent dividers sx={{ pt: 1, pb: 0, border: 'none' }}>
        {(onCreate || onUpdate) && (
          <TextField
            fullWidth
            label="Folder name"
            value={files}
            onChange={setFiles}
            sx={{ mb: 3 }}
          />
        )}
        {files.length > 0 ?
        <div style={{display:'flex',alignItems:'center', justifyContent:'center'}}>
          <MultiFilePreview files={files} thumbnail={true} onRemove={handleRemoveFile}/>
          {/* <Upload files={files} onDrop={handleDrop} onRemove={handleRemoveFile} /> */}
        </div>
        :
          <Upload files={files} onDrop={handleDrop} onRemove={handleRemoveFile} />
        }
        
        
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          startIcon={<FileUploadIcon />}
          onClick={type === "user" ? handleUserDocumentUpload :  handleUpload}
          disabled={files.length <= 0}
        >
          Upload
        </Button>

        {!!files.length && (
          <Button variant="outlined" color="inherit" onClick={handleRemoveAllFiles}>
            Remove all
          </Button>
        )}

        {(onCreate || onUpdate) && (
          <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
            <Button variant="soft" onClick={onCreate || onUpdate}>
              {onUpdate ? 'Save' : 'Create'}
            </Button>
          </Stack>
        )}
      </DialogActions>
    </Dialog>
  );
}

